import { actionTypes as actionTypesNotif } from "redux/notificationAlert";
import { store } from "redux/store";
import { EMPTYALLREDUCERS } from "redux/type";
// import { actionTypes as actionTypesLogOut } from "../../../modules/Auth/_redux/authRedux";
let notificationHandled = false;

export const handleNotificationAlertTryUpdate = (responseData) => {
  const { dispatch } = store;
  if (notificationHandled) {
    return false;
  }
  if (responseData.status === 200 && responseData.data.response.is_successful) {
    dispatch({ type: actionTypesNotif.success });
    return true;
  }
  if (
    !notificationHandled &&
    responseData?.data?.error === "INVALID INPUT token: Not Authorized"
  ) {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "زمان ورود شما به پایان رسید، لطفا دوباره لاگین کنید.",
    });

    dispatch({
      type: actionTypesNotif.flagExpire,
      payload: true,
    });

    setTimeout(() => {
      document.cookie =
        "admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      window.location.assign("/auth");
      sessionStorage.setItem("redirectpath", window.location.pathname);
      sessionStorage.removeItem("hjViewportId");
    }, 2000);

    dispatch({ type: EMPTYALLREDUCERS });
    notificationHandled = true;

    // auth.logout(() => {
    // 	setTimeout(() => {
    // 		window.location.assign("/auth");
    // 	}, 3000);
    // });

    // dispatch({ type: actionTypesLogOut.Logout });

    return false;
  } else if (
    responseData.status === 403 &&
    responseData.error === "PERMISSION DENIED"
  ) {
    dispatch({
      type: "ALERT",
      payload: {
        status: true,
        textAlert: `شما دسترسی به انجام این عملیات را ندارید.`,
        typeAlert: "warning",
      },
    });
    return false;
  } else if (responseData.status !== 200) {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "ارتباط با سرور قطع می باشد",
    });
    return false;
  } else if (responseData.data.status !== 200) {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "ارتباط با سرور قطع می باشد.",
    });
    return false;
  } else if (
    responseData.status === 200 &&
    !responseData.data.response.is_successful
  ) {
    let textError = handelError(responseData.data.response.error_code);
    dispatch({ type: actionTypesNotif.warning, textAlert: textError });
    return false;
  } else {
    dispatch({
      type: actionTypesNotif.warning,
      textAlert: "مشکل رخ داده در لیست خطاها وجود ندارد.",
    });
    return false;
  }
};

export const handleNotificationAlertCatch = () => {
  const { dispatch } = store;

  dispatch({
    type: actionTypesNotif.error,
    textAlert: "در ارتباط با سرور مشکلی رخ داده است.",
    // payload: {
    //   status: true,
    //   typeAlert: "error"
    // }
  });
};

export const handleNotificationAlertTrySelect = (item) => {
  const { dispatch } = store;

  if (notificationHandled) {
    return false;
  }
  if (item?.data?.response?.is_successful) {
    return true;
  } else if (item.status !== 200) {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "ارتباط با سرور قطع می باشد.",
    });
    return false;
  }
  if (item.data.error === "INVALID INPUT token: Not Authorized") {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "زمان ورود شما به پایان رسید، لطفا دوباره لاگین کنید.",
    });

    dispatch({
      type: actionTypesNotif.flagExpire,
      payload: true,
    });

    setTimeout(() => {
      document.cookie =
        "admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

      const { pathname, search } = window.location;

      let redirectPath = "";
      if (pathname.startsWith("/marketer")) {
        redirectPath = pathname + search;
      } else {
        const firstSegment = pathname.split("/")[1];
        redirectPath = `/${firstSegment}${search}`;
      }

      const redirectUrl = `/auth?page=${encodeURIComponent(redirectPath)}`;

      window.location.assign(redirectUrl);

      sessionStorage.setItem("redirectpath", pathname);
      sessionStorage.removeItem("hjViewportId");
    }, 2000);

    dispatch({ type: EMPTYALLREDUCERS });
    notificationHandled = true;
    return false;
  } else if (
    item.data.status === 403 &&
    item.data.error === "PERMISSION DENIED"
  ) {
    dispatch({
      textAlert: `شما دسترسی به انجام این عملیات را ندارید.`,
      type: actionTypesNotif.warning,
    });
    return false;
  } else if (item.data.status !== 200) {
    dispatch({
      type: actionTypesNotif.error,
      textAlert: "ارتباط با سرور قطع می باشد.",
    });

    return false;
  } else if (!item.data.response.is_successful) {
    let textError = handelError(item.data.response.error_code);
    dispatch({ type: actionTypesNotif.warning, textAlert: textError });
    return false;
  } else {
    dispatch({
      type: actionTypesNotif.warning,
      textAlert: "مشکل رخ داده در لیست خطاها وجود ندارد.",
    });
  }
};

const handelError = (key) => {
  switch (key) {
    case 701:
      return "اجازه انجام عملیات را ندارید. ";
    case 601:
      return "مقادیر ارسالی پارامترها معتبر نیستند.";
    case 401:
      return "خطای عمومی ";
    case 501:
      return "سامانه رایان با خطا روبرو شد.";
    case 801:
      return "عدم رعایت وابستگی ها";
    case 602:
      return "یک فیلد اجباری ارسال نشده است.";
    case 603:
      return "مقدار یکی از فیلدهای ارسالی معتبر نیست.";
    case 604:
      return "نام یکی از فیلدهای ارسالی معتبر نیست.";
    case 605:
      return "کاربر مورد نظر یافت نشد";
    case 901:
      return "فروم مورد نظر یافت نشد. ";
    case 101101:
      return "ظرفیت دوره به پایان رسیده است.";
    case 101201:
      return "عدم امکان ویرایش دوره";
    case 101301:
      return "شما قابل در این دوره ثبت نام کرده اید.";
    case 101401:
      return "وضعیت ثبتنام در دوره نامعتبر است.";
    case 101501:
      return "عدد منفی نباید وارد کنید";
    case 101601:
      return "تاریخ پایان باید بعد از تاریخ شروع باشد";
    case 101701:
      return "تاریخ پایان ثبت نام باید بعد از تاریخ امروز باشد";
    case 102101:
      return "امتیاز کاربر برای انجام عملیات کافی نیست";
    case 102201:
      return "امکان ویرایش مقادیر امتیاز وجود ندارد.";
    case 102301:
      return "امکان رزرو امتیاز وجود ندارد.";
    case 102303:
      return "کاربر عضو باشگاه نیست.";
    case 102401:
      return "مکان رولبک امتیاز وجود ندارد. ";
    case 102501:
      return "امکان نهاییسازی امتیاز وجود ندارد.";
    case 102601:
      return "امکان لغو امتیاز وجود ندارد. ";
    case 103101:
      return "ظرفیت مسابقه تکمیل شده است.";
    case 103201:
      return "امکان ویرایش مسابقه وجود ند ارد";
    case 103301:
      return "امکان نهاییسازی مسابقه وج ود ندا رد.";
    case 103401:
      return "شما قابل در این مسابقه ثبت نام کردهاید.";
    case 104101:
      return "وضعیت پیام معتبر نیست.";
    case 105101:
      return "امکان ویرایش امتیاز وجود ندارد.";
    case 105201:
      return "تصویر پروفایل بزرگتر از حد مجاز است.";
    case 105804:
      return "کد تایید را به درستی وارد نمایید";
    case 105805:
      return "در حال حاضر دسترسی به سامانه امکان‌پذیر نیست. لطفا بعدا تلاش فرمایید";
    case 105301:
      return "کاربر گرامی ایمیل شما ثبت نشده است";
    case 105302:
      return "خطا در ارسال پیامک رخ داده است";
    case 105401:
      return "کاربر گرامی شماره موبایل شما ثبت نشده است";
    case 105501:
      return "رکورد فراموشی یافت نشد لطفاً دوباره درخواست فراموشی رمز عبور بدهید";
    case 105601:
      return "اطلاعات نامعتبر است لطفاً از صحت لینک اطمینان حاصل کنید";
    case 105701:
      return "کاربر گرامی تعداد درخواستهای پیامک شما بیش از حد مجاز است ";
    case 105801:
      return "شما در حال حاضر عضو باشگاه هستید. اگر قصد بازیابی رمز عبور خود را دارید لطفاً به صفحه ورود مراجعه نمایید";
    case 105802:
      return "اطلاعاتی برای فعالسازی یافت نشد در صورتی که از اطلاعات وارد شده مطمئن هستید و این خطا را دریافت می کنید با واحد پشتیبانی مبین سرمایه (0211579) تماس بگیرید";
    case 105803:
      return "کد فعالسازی وارد نشده است";
    case 105812:
      return "شما عضو کارگزاری پیشرو نیستید! برای وارد شدن ، ابتدا باید عضو کارگزاری شوید.";
    case 105813:
      return "کابر گرامی برای ورود ابتدا باید عضو سامانه سجام باشید.";
    case 105901:
      return "رمز عبور بایستی شامل حداقل یک حرف بزرگ، یک حرف کوچک و یک رقم و حداقل 8 کاراکتر باشد";
    case 105902:
      return "نام کاربری تکراری است لطفاً نام کاربری دیگری انتخاب نمایید";
    case 105903:
      return "مشتری گرامی از مهلت تغییر معرف شما بیش از سه روز گذاشته است و در حال حاضر شما مجاز به وارد کردن معرف نمی باشید";
    case 105904:
      return "مشتری گرامی قبلا معرف شما ثبت شده است";
    case 105912:
      return "نام کاربری یا رمز عبور اشتباه می‌باشد";
    case 105920:
      return "اطلاعات وارد شده برای بانک  متعلق به کاربر نیست.";
    case 106101:
      return "اطلاعات اعتبار شما در دسترس نیست. لطفا با پشتیبانی تماس بگیرید.";
    case 106201:
      return "سامانه پروفایلینگ درحال حاضر در دسترس نیست. لطفا پس از مدتی دوباره تلاش نمایید.";
    case 106202:
      return "مشکلی در اطلاعات سبد سهام شما وجود دارد. لطفا برای رفع مشکل با واحد پشتیبانی تماس بگیرید";
    case 106203:
      return "در حال حاضر دسترسی به سبد سهام شما وجود ندارد. لطفا، مدتی بعد دوباره تلاش بفرمایید.";
    case 106204:
      return "وضعیت اعتبار جاری مبهم است. لطفا با واحد فنی تماس بگیرید.";
    case 106301:
      return "مطابق با ضوابط، شما امکان درخواست این طرح را ندارید.";
    case 106302:
      return "طرح اعتباری درخواست شده در حال حاضر قابل ارائه نیست.";
    case 106303:
      return "درخواست این طرح برای افراد زیر ۱۸ سال امکان‌پذیر نیست.";
    case 106304:
      return "طبق قوانین، پرسنل کارگزاری یا افراد تحت تکفل ایشان امکان دریافت اعتبار را ندارند.";
    case 106305:
      return "درخواست این طرح برای مشتریان اعتباری کارگزاری قابل ارائه نیست.";
    case 106307:
      return "مطابق قوانین، مشتریانی که اجازه خالی‌فروشی دارند، امکان درخواست اعتبار ندارند. لطفا با پشتیبانی تماس بگیرید.";
    case 106306:
      return "درخواست این طرح برای کاربران پنل اکسیر امکان‌پذیر نیست. لطفا پنل معاملاتی خود را به تدبیر تغییر دهید.";
    case 106401:
      return " با توجه به وضعیت درخواست، امکان انجام این عملیات وجود ندارد.";
    case 106402:
      return " شما یک درخواست دیگر با همین مشخصات در سامانه ثبت‌کرده‌اید که در حال پیگیری است.";
    case 106403:
      return " در حال حاضر یک طرح اعتباری مشابه برای شما در حال اجرا است.";
    case 106404:
      return "وضعیت درخواست قبلی مشخص نیست. لطفا با واحد پشتیبانی تماس بگیرید.";
    case 106501:
      return "سامانه اعتبار در حال حاضر در دسترس نیست. لطفا پس از مدتی دوباره تلاش نمایید.";
    case 106601:
      return "برای تمدید اعتبار باید ابتدا اعتبار فعلی را تسویه نمایید.";
    case 106602:
      return "برای تسویه اعتبار باید با فروش سهام یا واریز وجه در پنل معاملات، مانده منفی خود را تسویه نمایید.";
    case 106603:
      return "درخواست تسویه قبل از ساعت ۱۵ امکان پذیر نیست.";
    case 107101:
      return "سفارش با وضعیت کنسل شده قابل ثبت نیست";
    case 108701:
      return "در حال حاضر امکان درخواست این جایزه وجود ندارد";
    case 108801:
      return "کسی در قرعه کشی ثبت نام نکرده است";
    case 109301:
      return "عضو قبلاً درخواست تغییر کارگزار مشابهی را ارسال کرده است.";
    case 110104:
      return "شما قبلا ثبت نام کرده اید";
    case 110103:
      return "عرضه اولیه غیر فعال می باشد";
    case 110301:
      return "این درخواست قبلا لغو شده است";
    case 110106:
      return "کاربر مورد نظر مشتری نمی باشد";
    case 112100:
      return "اطلاعات سبد سهام در دسترس نیست.";
    case 114501:
      return "ثبت سفارش با خطا مواجه شد.";
    case 115302:
      return "مشتری با این کد ملی، در اتوماسیون ثبت شده است.";
    case 115310:
      return "selfApiDescription";
    case 120102:
      return "این کد تخفیف قبلا استفاده شده است";
    case 128101:
      return "این نقش تکراری است";
    case 136101:
      return "شناسه فرزند نادرست است.";
    case 136102:
      return "اطلاعات سبد سهام فرزند شما در دسترس نیست. لطفا با پشتیبانی تماس بگیرید.";
    case 136201:
      return " مبلغ درخواستی بیشتر از مانده قابل انتقال است.";
    case 136202:
      return " تصویر امضای شما در سامانه سجام ثبت نشده است. برای ویرایش با آدرس https://sejam.ir مراجعه نمایید.";
    case 136301:
      return "کد کپچا اشتباه وارد شده است.";
    case 136302:
      return " امکان ارسال پیامک در حال حاضر وجود ندارد. لطفا بعد از مدتی دوباره تلاش فرمایید.";
    case 136303:
      return "  کد تایید پیامکی، منقضی شده است. لطفا دوباره تلاش فرمایید.";
    case 136203:
      return "متاسفانه شما امکان برداشت وجه از حساب خود را ندارید. لطفا با پشتیبانی تماس بگیرید.";
    case 136204:
      return "تعداد درخواست‌های سجام از حد مجاز گذشته است. لطفا پس از گذشت چند دقیقه دوباره تلاش نمایید.";
    case 137601:
      return "نماد اول در پورتفوی لحظه‌ای وجود ندارد. لطفا ابتدا اقدام به خرید این نماد نمایید.";
    case 137602:
      return "تعداد انتخاب شده بیشتر از حجم موجود در سبد سهام شماست.";
    case 137603:
      return "نمادهای انتخاب شده مطابق با استراتژی با هم هم‌خوانی ندارند.";
    case 137604:
      return "شما دسترسی موقعیت فروش ندارید، با پشتیبانی تماس بگیرید.";
    case 139101:
      return "وضعیت درخواست این اجازه را به شما نمیدهد.";
    case 139201:
      return "کد بورسی انتخاب شده معتبر نیست.";
    case 139202:
      return "سهام انتخاب شده معتبر نیست.";
    case 139203:
      return "مبلغ وارد شده معتبر نیست";
    case 139204:
      return "موعد برداشت معتبر نیست.";
    case 139205:
      return "تاریخ پایان قرارداد معتبر نیست.";
    case 139206:
      return "تاریخ شروع قرارداد معتبر نیست.";
    case 139301:
      return "خطای ایجاد قرارداد. لطفا با پشتیبانی تماس بگیرید.";
    case 139401:
      return "اطلاعات قرارداد دریافت نشد. بعد از چند دقیقه دوباره تلاش کنید.";
    case 139402:
      return "فعال‌سازی انجام نشد. با پشتیبانی تماس بگیرید.";
    case 135701:
      return "سرویس در ساعت ۱۵:۰۰ تا ۱۸:۰۰ در دسترس نمی باشد. لطفا در خارج از این زمان درخواست دهید.";
    case 135702:
      return "سقف درخواست برداشت وجه روزانه پنجاه میلیون تومن میباشد.";
    case 135703:
      return "درخواست شما با خطا مواجه شد، در هر رور بیشتر از یک درخواست نمیتوان ثبت کرد.";

    case 135704:
      return "مانده شما برای انجام این عملیات کافی نمی باشد.";
    case 135705:
      return ". لطفا مجددا فردا بررسی بفرمایید امکان انجام درخواست شما برای امروز ممکن  نیست";
    case 135706:
      return "برای امروز درخواست شما ثبت شده است . لطفا مجددا فردا بررسی بفرمایید";

    case 135707:
      return "سامانه بانک در حال حاضر در دسترس نمی باشد.";
    case 135709:
      return "شما به دلیل داشتن اعتبار امکان انجام این عملیات را ندارید.";
    case 135710:
      return "شما به دلیل داشتن موقعیت فروش امکان انجام این عملیات را ندارید.";
    case 135711:
      return "مبلغ درخواست شما بیشتر از سقف مجاز برای شما می باشد.";
    case 135712:
      return "به دلیل داشتن دسترسی فروش ، امکان انجام عملیات نیست.";
    case 105602:
      return "شما از این رمز در گذشته استفاده کردید. لطفا رمز عبور جدیدی وارد کنید";
    case 140001:
      return "اطلاعات پرتفوی در دسترس نمی باشد .";
    case 140002:
      return "کد تایید وارد شده معتبر نمی باشد";
    case 140003:
      return "امکان ثبت درخواست برای کارکنان کارگزاری امکان پذیر نیست.";
    case 140004:
      return "امکان ثبت درخواست شما به علت درخواست طرح اعتبار فیبو امکان پذیر نیست.";
    case 140101:
      return "اطلاعات پرتفوی در دسترس نمی باشد .";
    case 140102:
      return "کد تایید وارد شده معتبر نمی باشد";
    case 140103:
      return "امکان ثبت درخواست برای کارکنان کارگزاری امکان پذیر نیست.";
    case 140104:
      return "امکان ثبت درخواست شما به علت درخواست طرح اعتبار فیبو امکان پذیر نیست.";
    case 140105:
      return "کاربر مورد نظر یافت نشد.";
    case 140109:
      return "شما به دلیل داشتن دسترسی فروش اجازه انجام عملیات را ندارید.";
    case 135807:
      return "یک درخواست در حال انتظار برای شما در جریان است.";
    default:
      return "در حال حاضر امکان این عملیات وجود ندارد";
  }
};
